import useApiHelpers from "@/composables/api/helpers";

const { getRequest } = useApiHelpers();

export default function useOrderEndpoints() {
  const getFiats = async (orderType = "buy") => {
    return getRequest(`/fiats/${orderType}`);
  };

  const getCoins = async (orderType = "buy") => {
    return getRequest(`/coins/${orderType}`);
  };

  const getOrderSummary = async (orderId) => {
    return getRequest(`/status/${orderId}`);
  };

  const initOrder = async () => {
    return getRequest(`/init`);
  };

  return {
    getFiats,
    getCoins,
    initOrder,
    getOrderSummary,
  };
}
